import MovieHeader from './movie-header';

export default MovieHeader;
